import React from "react";
import { CgColorPicker } from "react-icons/cg";

export const AppearanceSettings = () => {
  const changeBackgroundHandler = (e) => {
    e.target.classList.toggle("selected");
  };

  return (
    <div className="change-settings-container">
      <h1>Appearance:</h1>
      <div id="dashboardBackgrounds">
        <h3>Dashboard Background</h3>
        <div className="bg-options ">
          <div className="bg-slot bg-color">
            <CgColorPicker id="color-picker" />
          </div>
          <div
            onClick={(e) => changeBackgroundHandler(e)}
            className="bg-slot color1"
          ></div>
          <div
            onClick={(e) => changeBackgroundHandler(e)}
            className="bg-slot color2"
          ></div>
          <div
            onClick={(e) => changeBackgroundHandler(e)}
            className="bg-slot color3"
          ></div>
        </div>
      </div>
    </div>
  );
};
